export interface Author {
  id: string
  name: string
  bio: string
  image: string
  username?: string
  type?: 'fiction' | 'nonfiction' | 'poetry'
  genres?: string[]
  followers?: number
  works?: number
  awards?: number
  socialLinks?: {
    instagram?: string
    twitter?: string
    facebook?: string
    youtube?: string
  }
}
export interface BookPreview {
  enabled: boolean
  percentage: number
  whitelist: string[]
  timeWindow: {
    enabled: boolean
    startDate: string
    endDate: string
  }
  content?: string
}
export interface RightsTransfer {
  active: boolean
  progress?: number
  budget?: string
  raised?: string
  investors?: number
  rightsPercentage?: number
  daysLeft?: number
}
export interface Book {
  id: string
  cover: string
  title: string
  genre: string
  year: string
  status: 'published' | 'unpublished' | 'in-progress' | 'in-transfer'
  description: string
  pages: number
  publisher: string
  author: Author
  preview: BookPreview
  rightsTransfer: RightsTransfer
  rating?: number
  readers?: number
}
export const authors: Author[] = [
  {
    id: '1',
    name: 'Marco Bianchi',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
    type: 'fiction',
    genres: ['Fantasia', 'Avventura', 'Romanzo'],
    bio: 'Autore di bestseller con una passione per la narrativa fantastica. Ha pubblicato oltre 10 romanzi tradotti in diverse lingue.',
    followers: 2400,
    works: 12,
    awards: 3,
    username: 'marcobianchi_autore',
    socialLinks: {
      instagram: 'https://instagram.com/marcobianchi',
      twitter: 'https://twitter.com/marcobianchi',
      facebook: 'https://facebook.com/marcobianchi',
      youtube: 'https://youtube.com/marcobianchi',
    },
  },
  {
    id: '2',
    name: 'Laura Verdi',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    type: 'fiction',
    genres: ['Romanzo', 'Drammatico'],
    bio: 'Scrittrice e giornalista, ha vinto numerosi premi letterari. La sua scrittura esplora le dinamiche familiari e le relazioni interpersonali.',
    followers: 1800,
    works: 8,
    awards: 2,
    username: 'lauraverdi_autrice',
    socialLinks: {
      instagram: 'https://instagram.com/lauraverdi',
      twitter: 'https://twitter.com/lauraverdi',
      facebook: 'https://facebook.com/lauraverdi',
      youtube: 'https://youtube.com/lauraverdi',
    },
  },
  {
    id: '3',
    name: 'Giovanni Russo',
    image: 'https://randomuser.me/api/portraits/men/41.jpg',
    type: 'nonfiction',
    genres: ['Saggistica', 'Scienza', 'Divulgazione'],
    bio: 'Saggista e divulgatore scientifico, collabora con diverse riviste del settore. I suoi libri rendono accessibili concetti complessi.',
    followers: 1200,
    works: 5,
    awards: 1,
    username: 'giovannirusso_autore',
    socialLinks: {
      instagram: 'https://instagram.com/giovannirusso',
      twitter: 'https://twitter.com/giovannirusso',
      facebook: 'https://facebook.com/giovannirusso',
      youtube: 'https://youtube.com/giovannirusso',
    },
  },
  {
    id: '4',
    name: 'Elena Neri',
    image: 'https://randomuser.me/api/portraits/women/33.jpg',
    type: 'poetry',
    genres: ['Poesia', 'Lirica'],
    bio: 'Poetessa contemporanea, le sue raccolte esplorano temi esistenziali e sociali con uno stile evocativo e coinvolgente.',
    followers: 950,
    works: 6,
    awards: 2,
    username: 'elenaneri_autrice',
    socialLinks: {
      instagram: 'https://instagram.com/elenaneri',
      twitter: 'https://twitter.com/elenaneri',
      facebook: 'https://facebook.com/elenaneri',
      youtube: 'https://youtube.com/elenaneri',
    },
  },
  {
    id: '5',
    name: 'Roberto Mari',
    image: 'https://randomuser.me/api/portraits/men/22.jpg',
    type: 'fiction',
    genres: ['Thriller', 'Giallo', 'Noir'],
    bio: 'Autore di thriller psicologici, i suoi romanzi sono caratterizzati da trame avvincenti e personaggi complessi.',
    followers: 1600,
    works: 7,
    awards: 1,
  },
  {
    id: '6',
    name: 'Carla Esposito',
    image: 'https://randomuser.me/api/portraits/women/56.jpg',
    type: 'nonfiction',
    genres: ['Biografia', 'Storia', 'Saggistica'],
    bio: 'Biografa e storica, i suoi libri raccontano le vite di personaggi che hanno segnato la storia italiana e internazionale.',
    followers: 1100,
    works: 9,
    awards: 2,
  },
  {
    id: '7',
    name: 'Antonio Ricci',
    image: 'https://randomuser.me/api/portraits/men/45.jpg',
    type: 'fiction',
    genres: ['Storico', 'Romanzo'],
    bio: "Scrittore di romanzi storici ambientati nell'Italia del Rinascimento, noti per la precisione dei dettagli e la vivacità narrativa.",
    followers: 1900,
    works: 11,
    awards: 3,
  },
  {
    id: '8',
    name: 'Sofia Martini',
    image: 'https://randomuser.me/api/portraits/women/67.jpg',
    type: 'poetry',
    genres: ['Poesia', 'Haiku', 'Versi liberi'],
    bio: 'Le sue poesie, tradotte in diverse lingue, esplorano il rapporto tra natura e umanità con uno stile lirico e contemplativo.',
    followers: 850,
    works: 4,
    awards: 1,
  },
]
export const books: Book[] = [
  {
    id: '1',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/67FfJDXox9973Yr212r9mt/IMG_0033.webp',
    title: 'Il Giardino Tra Le Nuvole',
    genre: 'Romanzo',
    year: '2023',
    status: 'in-progress',
    description:
      "Un romanzo avvincente che esplora le complessità dell'animo umano attraverso la storia di un giardiniere che scopre un mondo magico nascosto tra le nuvole. Tra avventura e introspezione, il protagonista intraprende un viaggio di scoperta personale che cambierà per sempre la sua percezione della realtà.",
    pages: 342,
    publisher: 'Edizioni Stellari',
    author: authors[0],
    preview: {
      enabled: true,
      percentage: 15,
      whitelist: ['mario.rossi@example.com', 'giulia.bianchi@example.com'],
      timeWindow: {
        enabled: true,
        startDate: '2023-10-01',
        endDate: '2023-12-31',
      },
      content: `
        <h2>Capitolo 1 - L'incontro</h2>
        <p>Il sole filtrava attraverso le foglie del vecchio quercia, creando un mosaico di luci e ombre sul terreno del giardino. Marco si chinò per osservare più da vicino il terreno appena smosso, soddisfatto del lavoro svolto. Era il suo primo giorno come giardiniere della villa e voleva fare una buona impressione.</p>
        <p>La proprietà apparteneva a una donna anziana, la signora Adelina, che raramente si faceva vedere. Gli altri domestici parlavano di lei con un misto di rispetto e timore, come se custodisse qualche segreto. Marco non era interessato ai pettegolezzi; amava solo le piante e il modo in cui poteva dar loro forma e vita.</p>
        <p>Mentre si rialzava per ammirare il risultato del suo lavoro, notò qualcosa di strano tra i cespugli di rose. Un riflesso, come di vetro o acqua, che sembrava fluttuare nell'aria. Si avvicinò incuriosito, pensando fosse un effetto della luce del sole.</p>
        <p>Ma più si avvicinava, più il fenomeno diventava chiaro e definito. Non era un riflesso, ma una sorta di apertura, come se l'aria stessa si fosse aperta in una finestra trasparente. E attraverso quella finestra, Marco poteva vedere... nuvole. Non il cielo sopra di lui, ma un mare di nuvole bianche e soffici che si estendeva all'infinito.</p>
        <p>Sbatté le palpebre più volte, convinto di avere un'allucinazione. Forse il caldo o la stanchezza gli stavano giocando un brutto scherzo. Ma quando allungò la mano verso quella strana apertura, le sue dita attraversarono il vuoto e sentì una brezza fresca accarezzargli la pelle.</p>
        <p>Fu in quel momento che udì una voce alle sue spalle.</p>
        <p>"Vedo che hai trovato il passaggio."</p>
        <p>Marco si voltò di scatto. Davanti a lui c'era la signora Adelina, una donna dall'aspetto fragile ma con occhi sorprendentemente vivaci e penetranti.</p>
        <p>"Mi dispiace, io non volevo..." iniziò a scusarsi Marco, temendo di aver fatto qualcosa di sbagliato.</p>
        <p>"Non scusarti," lo interruppe lei con un sorriso. "Non tutti possono vederlo. Solo chi ha un legame speciale con la natura. Come te."</p>
        <p>Marco guardò nuovamente l'apertura, poi tornò a fissare la donna anziana. "Cos'è... cosa c'è dall'altra parte?"</p>
        <p>La signora Adelina si avvicinò lentamente, appoggiandosi a un bastone intagliato. "Dall'altra parte c'è un giardino. Un giardino tra le nuvole, dove crescono piante che qui sulla terra non esistono più o non sono mai esistite. È lì che vado quando questo mondo diventa troppo... ordinario."</p>
        <p>Gli occhi di Marco si spalancarono per lo stupore. Parte di lui voleva credere che fosse tutto uno scherzo elaborato, ma un'altra parte, più profonda e istintiva, sapeva che la donna stava dicendo la verità.</p>
        <p>"Vuoi vedere?" chiese la signora Adelina, tendendo la mano verso di lui.</p>
        <p>Marco esitò solo un istante prima di prenderla. E insieme, fecero un passo attraverso quella finestra nell'aria, verso un mondo di nuvole e meraviglie sconosciute.</p>
        <h2>Capitolo 2 - Il Giardino Sospeso</h2>
        <p>Il primo passo oltre la soglia fu come immergersi in acqua tiepida. Marco sentì un formicolio diffondersi dalla punta delle dita fino alla nuca, e per un istante ebbe l'impressione che il suo corpo si dissolvesse in mille particelle luminose. Poi, improvvisamente, tutto si ricompose.</p>
      `,
    },
    rightsTransfer: {
      active: true,
      progress: 65,
      budget: '€15,000',
      raised: '€9,750',
      investors: 17,
      rightsPercentage: 30,
      daysLeft: 23,
    },
    rating: 4.7,
    readers: 1200,
  },
  {
    id: '2',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/mtjbM3md9CHGw28ZmhqgeV/IMG_0035.webp',
    title: 'Amori & Bugie',
    genre: 'Romanzo',
    year: '2022',
    status: 'published',
    description:
      "Un intenso racconto di relazioni complesse e segreti familiari che emergono dopo anni di silenzio. Ambientato nella pittoresca costa amalfitana, il romanzo intreccia storie d'amore, tradimenti e riconciliazioni in un affresco emotivo di grande impatto.",
    pages: 278,
    publisher: 'Mondadori',
    author: authors[1],
    preview: {
      enabled: false,
      percentage: 10,
      whitelist: [],
      timeWindow: {
        enabled: false,
        startDate: '',
        endDate: '',
      },
    },
    rightsTransfer: {
      active: false,
    },
    rating: 4.5,
    readers: 3500,
  },
  {
    id: '3',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp',
    title: 'Il Bosco di Nebbia',
    genre: 'Thriller',
    year: '2021',
    status: 'published',
    description:
      "Un thriller psicologico che tiene il lettore col fiato sospeso fino all'ultima pagina. Quando una serie di misteriose sparizioni colpisce un piccolo villaggio ai margini di un bosco avvolto nella nebbia, un detective tormentato dal suo passato dovrà affrontare non solo un killer sfuggente ma anche i propri demoni personali.",
    pages: 412,
    publisher: 'Feltrinelli',
    author: authors[4],
    preview: {
      enabled: false,
      percentage: 10,
      whitelist: [],
      timeWindow: {
        enabled: false,
        startDate: '',
        endDate: '',
      },
    },
    rightsTransfer: {
      active: true,
      progress: 100,
      budget: '€12,000',
      raised: '€12,000',
      investors: 24,
      rightsPercentage: 40,
      daysLeft: 0,
    },
    rating: 4.8,
    readers: 4200,
  },
  {
    id: '4',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/omrsrDbXdUTTrHR98EvY6a/IMG_0034.webp',
    title: 'Il mio diario delle preghiere',
    genre: 'Spirituale',
    year: '2020',
    status: 'published',
    description:
      'Una raccolta intima e profonda di preghiere e riflessioni spirituali che accompagnano il lettore in un percorso di crescita interiore e connessione con il divino. Ogni pagina offre spunti di meditazione e conforto per affrontare le sfide quotidiane con fede e speranza.',
    pages: 186,
    publisher: 'San Paolo Edizioni',
    author: authors[3],
    preview: {
      enabled: true,
      percentage: 20,
      whitelist: [],
      timeWindow: {
        enabled: false,
        startDate: '',
        endDate: '',
      },
    },
    rightsTransfer: {
      active: false,
    },
    rating: 4.3,
    readers: 1800,
  },
  {
    id: '5',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/mH3hvE4SdWb6hacSUtkerR/IMG_0029.webp',
    title: 'Pensa Come Un Boss',
    genre: 'Sviluppo personale',
    year: '2021',
    status: 'unpublished',
    description:
      'Una guida pratica e motivazionale che rivela le strategie mentali dei leader di successo. Attraverso esempi concreti, esercizi e tecniche collaudate, il libro insegna come sviluppare una mentalità vincente, prendere decisioni efficaci e guidare con autorevolezza in ogni contesto professionale e personale.',
    pages: 245,
    publisher: 'ROI Edizioni',
    author: authors[2],
    preview: {
      enabled: true,
      percentage: 15,
      whitelist: ['test@example.com'],
      timeWindow: {
        enabled: true,
        startDate: '2023-01-01',
        endDate: '2023-12-31',
      },
    },
    rightsTransfer: {
      active: false,
    },
    rating: 4.2,
    readers: 950,
  },
  {
    id: '6',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp',
    title: "L'Eco Silenzioso",
    genre: 'Narrativa',
    year: '2019',
    status: 'in-transfer',
    description:
      "Un romanzo lirico e contemplativo che esplora il tema del silenzio in un mondo sempre più rumoroso. Attraverso la storia di un musicista che perde l'udito, l'autore ci conduce in un viaggio sensoriale unico, dove il silenzio diventa una forma di comunicazione più profonda delle parole stesse.",
    pages: 320,
    publisher: 'Einaudi',
    author: authors[6],
    preview: {
      enabled: false,
      percentage: 10,
      whitelist: [],
      timeWindow: {
        enabled: false,
        startDate: '',
        endDate: '',
      },
    },
    rightsTransfer: {
      active: true,
      progress: 75,
      budget: '€10,000',
      raised: '€7,500',
      investors: 15,
      rightsPercentage: 35,
      daysLeft: 12,
    },
    rating: 4.6,
    readers: 2700,
  },
  {
    id: '7',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/67FfJDXox9973Yr212r9mt/IMG_0033.webp',
    title: "Versi dell'Anima",
    genre: 'Poesia',
    year: '2024',
    status: 'unpublished',
    description:
      "Una raccolta di poesie che esplora le profondità dell'animo umano, le sue fragilità e la sua forza. Versi che parlano di amore, perdita, speranza e rinascita, in un linguaggio evocativo che risuona nell'intimo del lettore e lo invita a riflettere sulla propria esperienza esistenziale.",
    pages: 124,
    publisher: 'Autopubblicato',
    author: authors[7],
    preview: {
      enabled: true,
      percentage: 25,
      whitelist: [],
      timeWindow: {
        enabled: false,
        startDate: '',
        endDate: '',
      },
    },
    rightsTransfer: {
      active: false,
    },
    rating: 4.4,
    readers: 780,
  },
  {
    id: '8',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/mtjbM3md9CHGw28ZmhqgeV/IMG_0035.webp',
    title: 'Riflessioni Moderne',
    genre: 'Saggi',
    year: '2024',
    status: 'in-progress',
    description:
      "Una serie di saggi illuminanti che analizzano le sfide e le opportunità della società contemporanea. Dall'impatto della tecnologia sulle relazioni umane ai nuovi paradigmi economici, dall'evoluzione dei valori sociali alle questioni ambientali, il libro offre prospettive originali e stimolanti su temi di grande attualità.",
    pages: 298,
    publisher: 'Il Mulino',
    author: authors[5],
    preview: {
      enabled: false,
      percentage: 10,
      whitelist: [],
      timeWindow: {
        enabled: false,
        startDate: '',
        endDate: '',
      },
    },
    rightsTransfer: {
      active: false,
    },
    rating: 4.1,
    readers: 620,
  },
  {
    id: '9',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp',
    title: 'Ombre dal Passato',
    genre: 'Thriller',
    year: '2022',
    status: 'published',
    description:
      'Un thriller avvincente che esplora i segreti sepolti di una piccola comunità montana. Quando antichi crimini tornano a galla, nessuno è al sicuro dalle ombre del passato.',
    pages: 356,
    publisher: 'Mondadori',
    author: authors[4],
    preview: {
      enabled: true,
      percentage: 15,
      whitelist: [],
      timeWindow: {
        enabled: false,
        startDate: '',
        endDate: '',
      },
    },
    rightsTransfer: {
      active: false,
    },
    rating: 4.9,
    readers: 5100,
  },
  {
    id: '10',
    cover:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/mH3hvE4SdWb6hacSUtkerR/IMG_0029.webp',
    title: 'La Scienza del Quotidiano',
    genre: 'Divulgazione',
    year: '2023',
    status: 'published',
    description:
      'Un viaggio affascinante attraverso i fenomeni scientifici che incontriamo ogni giorno senza rendercene conto. Dalla chimica della cucina alla fisica dei trasporti, questo libro rende la scienza accessibile e sorprendente.',
    pages: 230,
    publisher: 'Zanichelli',
    author: authors[2],
    preview: {
      enabled: true,
      percentage: 20,
      whitelist: [],
      timeWindow: {
        enabled: false,
        startDate: '',
        endDate: '',
      },
    },
    rightsTransfer: {
      active: true,
      progress: 45,
      budget: '€8,000',
      raised: '€3,600',
      investors: 9,
      rightsPercentage: 25,
      daysLeft: 30,
    },
    rating: 4.7,
    readers: 1500,
  },
]
// Funzione helper per ottenere un libro dal suo ID
export const getBookById = (id: string): Book | undefined => {
  return books.find((book) => book.id === id)
}
// Funzione helper per ottenere i libri di un autore
export const getBooksByAuthor = (authorId: string): Book[] => {
  return books.filter((book) => book.author.id === authorId)
}
// Funzione helper per ottenere un autore dal suo ID
export const getAuthorById = (id: string): Author | undefined => {
  return authors.find((author) => author.id === id)
}
